<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    탈퇴회원관리
                </div>
                <div class="list-content">
                    <member-list-component :memberType="`quit`"></member-list-component>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
    </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import MemberListComponent from "@/components/member/MemberListComponent";

export default {
    name: "MemberQuit",
    mixins: [],
    components: {MemberListComponent},
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {

    },
    watch: {},
}
</script>

<style scoped>

</style>